/** Shared success story card data for Start portal and CRM Assessment template. */
export const SUCCESS_STORY_CARDS = [
  {
    contractorType: 'Design-Build',
    title: 'Startup to Scaled Operator',
    location: 'East Coast',
    time: '3 Years',
    revenueRange: '0-1M',
    problem: [],
    fix: [],
    result: ['$0 → $4.2M', '0% → 40% gross profit margin']
  },
  {
    contractorType: 'Design-Build',
    title: 'Stuck at ~$850k for 6 Years',
    location: 'West Coast',
    time: '1 Year',
    revenueRange: '0-1M',
    problem: [],
    fix: [],
    result: ['$850k → $2.8M', '1.66% → 8.71% net margin']
  },
  {
    contractorType: 'Design-Build',
    title: 'Growth-Stage Design-Build Firm',
    location: 'East Coast',
    time: '1 Year',
    revenueRange: '3-5M',
    problem: [],
    fix: [],
    result: ['$2.43M → $5.39M', 'Net Profit Increased 7%']
  },
  {
    contractorType: 'General Contractor',
    title: 'Scaling General Contractor',
    location: 'East Coast',
    time: '1 Year',
    revenueRange: '3-5M',
    problem: [],
    fix: [],
    result: ['$3.7M → $5.0M', 'Built Out Full Design Team']
  },
  {
    contractorType: 'Contractor',
    title: 'Financially Unstructured Contractor',
    location: 'East Coast',
    time: '1 Year',
    revenueRange: '5M+',
    problem: [],
    fix: [],
    result: [
      'BEFORE: Zero Understanding or Controls of Financials',
      'NOW: Full CFO Suite & Financial Dashboard',
      '0% → 10% net profit margin',
      'Full Systems (SOPs) Implementation'
    ]
  },
  {
    contractorType: 'Design Build',
    title: 'Low Margin Contractor',
    location: 'East Coast',
    time: '2 Years',
    revenueRange: '5M+',
    problem: [],
    fix: [],
    result: [
      'BEFORE: Constant Cost Overruns',
      '18% → 35% gross profit margin',
      'Full Pricing Awareness',
      'NOW: Modified Pricing Structure'
    ]
  }
];
